import { memo } from 'react'

const BuyPointsCard = () => {
  return null
}
// import ProviderCard from '../shared/exchangeProviderCard/ProviderCard'
// import BuyPointsProviderIcon from './BuyPointsProviderIcon'

// const BuyPointsCard = ({ provider, onClick }) => {
//   const { name } = provider
//   return (
//     <ProviderCard
//       label={name}
//       onClick={onClick}
//       icon={<BuyPointsProviderIcon {...provider} />}
//     />
//   )
// }

export default memo(BuyPointsCard)
